import Vue from 'vue';
import { TypeVipInfo, TypeVipService } from './index.interface';
import loginService from '../loginService/index';
import { commCgi } from '../../request';

// TODO: 请求方式待归一
const getSvip = async (): Promise<TypeVipInfo | null> => {
  try {
    const res = await commCgi('spp_SVipInfo', {
      cmd: 1,
      // eslint-disable-next-line
      source_scene: 4,
      hpic: 'no',
    });
    if (res.result?.code === 0) {
      return res as TypeVipInfo;
    }
    return null;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export class VipService implements TypeVipService {
  isInited = false

  isVip = false

  level = 0

  vipIcon = ''

  async init(): Promise<void> {
    await loginService.init();
    loginService.onLoginStateChange(async () => {
      await this.refresh();
    });
    await this.refresh();
    this.isInited = true;
  }

  async refresh(): Promise<void> {
    if (loginService.isLogin) {
      const svip = await getSvip();
      if (svip) {
        this.isVip = svip.hlw.vip === 1;
        this.level = svip.hlw.level;
        this.vipIcon = svip.sfw_hvip;
      }
    } else {
      this.isVip = false;
    }
  }
}

const vipService = Vue.observable(new VipService());
export default vipService;
